module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"平均買上点数"}}')
  delete Component.options._Ctor
}
